import { jsx as _jsx } from "react/jsx-runtime";

function SvgInvoice() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.818 1A2.818 2.818 0 001 3.818v2.273A1.91 1.91 0 002.91 8H4V6H3V3.818C3 3.366 3.366 3 3.818 3h16.364c.452 0 .818.366.818.818V6h-1.09v2h1.18A1.91 1.91 0 0023 6.09V3.819A2.818 2.818 0 0020.182 1H3.818zM6.41 5.1C5.41 5.1 4.6 5.91 4.6 6.909v15.09a.9.9 0 001.384.76l2.184-1.394a.01.01 0 01.011 0l.713.683c.7.67 1.802.67 2.502 0l.6-.574.002-.002H12.005l.001.002.6.574c.7.67 1.803.67 2.502 0l.713-.682a.01.01 0 01.011-.001l2.184 1.393A.9.9 0 0019.4 22V6.909c0-1-.81-1.81-1.809-1.81H6.409zM6.4 6.909v-.003l.001-.002.002-.002a.011.011 0 01.003-.002H17.596l.001.002a.012.012 0 01.003.003v13.453l-.8-.51a1.81 1.81 0 00-2.224.217l-.713.683-.001.001h-.001l-.004.001a.01.01 0 01-.003 0h-.001l-.002-.002-.6-.575c-.7-.67-1.802-.67-2.502 0l-.6.575a.011.011 0 01-.002.001l-.002.001h-.002a.01.01 0 01-.004 0l-.002-.002-.713-.683a1.81 1.81 0 00-2.224-.218l-.8.51V6.91zM8.364 12a1 1 0 011-1h5.272a1 1 0 110 2H9.364a1 1 0 01-1-1zm1 3a1 1 0 100 2h5.272a1 1 0 100-2H9.364z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgInvoice;